import React from 'react';
import * as PropTypes from 'prop-types';

import { Tooltip } from 'antd';
import { Popover } from '../../../../popovers';
import { SvgIcon } from '../../../../svg-icon';
import { theme } from '../../../../../styles';

import {
  RequestStatusDescription,
  RequestLabel,
  RequestLabelTitle,
  RequestLabelsWrapper,
} from '../../styled-components';
import { SvgWrapper } from '../styled-components';

const LabelPopover = ({ labels, color }) => {
  const labelsContent = (
    <RequestLabelsWrapper>
      {labels.map(label => (
        <RequestLabel
          isDescription={label.description}
          key={label._id}
          className="request-label"
          color={label.color}
        >
          <RequestLabelTitle>{label.title}</RequestLabelTitle>
          {label.description
            ? <Tooltip
              title={
                <RequestStatusDescription>
                  {label.description}
                </RequestStatusDescription>
              }
            >
              <SvgWrapper>
                <SvgIcon
                  type="info"
                  color={theme.colors.white}
                  fillOpacity={1}
                  isWithoutHover
                />
              </SvgWrapper>
            </Tooltip>
            : ''}
        </RequestLabel>
      ))}
    </RequestLabelsWrapper>
  );

  return (
    <Popover
      content={labelsContent}
      trigger="hover"
      placement="top"
    >
      <SvgIcon color={color} type="label" className="svg-icon" fillOpacity={1} />
    </Popover>
  );
};

LabelPopover.propTypes = {
  labels: PropTypes.array,
  color: PropTypes.string.isRequired,
};

LabelPopover.defaultProps = {
  labels: [],
};

export default LabelPopover;



// WEBPACK FOOTER //
// ./src/components/requests-list-item/request-header/counters/label-popover/index.js